// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/loading.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#afis-app section {
  border-top: 3px solid #666;
  border-bottom: 1px solid #ccc;
  padding: 0 13px 13px 13px;
  background-color: #fff;
  margin-top: 45px;
}
#afis-app #summary-section.sticky-margin-offset {
  margin-top: 180px;
}
#afis-app .newnNavigation.utility-bar {
  left: -13px;
  width: 102.58%;
}
#afis-app .newnNavigation.utility-bar .ns-site-switch.cg-bootstrap {
  height: 617px;
}
#afis-app .slide-enter-active {
  transition: all .3s ease;
}
#afis-app .slide-leave-active {
  transition: all 0.3s cubic-bezier(0, 1, 0.5, 1);
}
#afis-app .slide-enter,
#afis-app .slide-leave-to {
  transform: translateY(1px);
  opacity: 0;
}
#afis-app .clearfix:after {
  clear: both;
  display: table;
  content: "";
}
#afis-app .inner-container {
  margin-left: auto;
  margin-right: auto;
}
@media (min-width: 769px) {
  #afis-app .inner-container {
    width: 996px;
  }
}
#afis-app .outer-container {
  margin-left: auto;
  margin-right: auto;
  max-width: 996px;
}
#afis-app .soft-gray {
  background-color: #f9f9f9;
}
#afis-app .soft-gray .nav-responsive {
  border-bottom: 3px solid #666;
}
#afis-app .soft-gray .nav-selected {
  text-transform: uppercase;
  background-color: #33aee5;
  background-image: linear-gradient(to bottom, #33aee5, #009adf);
  background-image: -moz-linear-gradient(top, #33aee5, #009adf);
  background-image: -ms-linear-gradient(top, #33aee5, #009adf);
  background-image: -o-linear-gradient(top, #33aee5, #009adf);
  background-image: -webkit-gradient(linear, left top, left bottom, from(#33aee5), to(#009adf));
  background-image: -webkit-linear-gradient(top, #33aee5, #009adf);
  display: block;
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
  font-size: 18px;
  height: 36px;
  line-height: 36px;
  color: #fff;
}
#afis-app .soft-gray .nav-selected .nav-arrow-up {
  border-bottom: 8px solid #fff;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  content: "";
  display: block;
  margin-right: 6px;
  margin-top: 13px;
}
#afis-app .soft-gray .nav-selected .nav-arrow-down {
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #fff;
  content: "";
  display: block;
  margin-right: 6px;
  margin-top: 13px;
}
#afis-app .soft-gray .nav-list {
  display: block;
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
  font-size: 18px;
  list-style: none;
  margin: 0;
  padding: 0;
}
#afis-app .soft-gray .nav-list .nav-item {
  background-color: #999;
  background-image: linear-gradient(to bottom, #999, gray);
  background-image: -moz-linear-gradient(top, #999, gray);
  background-image: -ms-linear-gradient(top, #999, gray);
  background-image: -o-linear-gradient(top, #999, gray);
  background-image: -webkit-gradient(linear, left top, left bottom, from(#999), to(gray));
  background-image: -webkit-linear-gradient(top, #999, gray);
  color: #fff;
  display: block;
  height: 36px;
  line-height: 36px;
  text-transform: uppercase;
}
#afis-app .gray-bar-bottom {
  border-bottom: 1px solid #ccc;
}
#afis-app .gray-bar-top {
  border-top: 1px solid #ccc;
}
#afis-app #mega-menu[disabled] a {
  color: #1d5799;
  text-decoration: none;
}
#afis-app #header-row .logoCol img.logo {
  margin-left: 15%;
}
#afis-app a:hover {
  text-decoration: underline;
  cursor: pointer;
}
#afis-app .demi-font {
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
  font-size: 12px;
}
#afis-app .strong {
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif !important;
}
#afis-app .half-container {
  float: left;
  width: 49%;
}
#afis-app .flush-left {
  padding-left: 0 !important;
  margin-left: 0 !important;
}
#afis-app .flush-right {
  padding-right: 0 !important;
  margin-right: 0 !important;
}
#afis-app .com-mod-level-2-disclosure {
  font-size: 12px;
  font-family: "AvenirNextLTW01-Condens 721299", Arial;
  color: #666;
}
#afis-app .col-xs-1,
#afis-app .col-sm-1,
#afis-app .col-md-1,
#afis-app .col-lg-1,
#afis-app .col-xs-2,
#afis-app .col-sm-2,
#afis-app .col-md-2,
#afis-app .col-lg-2,
#afis-app .col-xs-3,
#afis-app .col-sm-3,
#afis-app .col-md-3,
#afis-app .col-lg-3,
#afis-app .col-xs-4,
#afis-app .col-sm-4,
#afis-app .col-md-4,
#afis-app .col-lg-4,
#afis-app .col-xs-5,
#afis-app .col-sm-5,
#afis-app .col-md-5,
#afis-app .col-lg-5,
#afis-app .col-xs-6,
#afis-app .col-sm-6,
#afis-app .col-md-6,
#afis-app .col-lg-6,
#afis-app .col-xs-7,
#afis-app .col-sm-7,
#afis-app .col-md-7,
#afis-app .col-lg-7,
#afis-app .col-xs-8,
#afis-app .col-sm-8,
#afis-app .col-md-8,
#afis-app .col-lg-8,
#afis-app .col-xs-9,
#afis-app .col-sm-9,
#afis-app .col-md-9,
#afis-app .col-lg-9,
#afis-app .col-xs-10,
#afis-app .col-sm-10,
#afis-app .col-md-10,
#afis-app .col-lg-10,
#afis-app .col-xs-11,
#afis-app .col-sm-11,
#afis-app .col-md-11,
#afis-app .col-lg-11,
#afis-app .col-xs-12,
#afis-app .col-sm-12,
#afis-app .col-md-12,
#afis-app .col-lg-12 {
  position: relative;
  min-height: 1px;
  padding-left: 13px;
  padding-right: 13px;
}
#afis-app .row {
  margin-left: -13px;
  margin-right: -13px;
}
#afis-app .not-found-outer {
  background: #f2f2f2;
}
#afis-app .not-found-outer hr {
  border-top: 1px solid #e5e5e5;
  margin-top: 80px;
  padding-bottom: 30px;
  width: 996px;
}
#afis-app .not-found-outer a {
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
}
#afis-app .not-found-outer .demi-font {
  height: 96px;
}
#afis-app .not-found-container {
  background: #fff;
  width: 996px;
}
#afis-app .not-found-container .ns-rte {
  margin-top: 25px;
  margin-bottom: 30px;
}
#afis-app .not-found-container .ns-rte p {
  margin: 0 0 9px;
  font-size: 14px;
  font-family: "AvenirNextLTW01-Regular", Arial, sans-serif;
  color: #333;
}
#afis-app .inline {
  display: inline;
}
@media (max-width: 768px) {
  #afis-app section {
    border-top: none;
    margin-top: 0;
  }
  #afis-app .com-mod-section-header {
    display: none;
  }
}
#afis-app .concise-sitemap a {
  color: #fff;
}
#afis-app .concise-sitemap [class*="span"] {
  margin-left: 21px;
}
#afis-app .concise-sitemap ul {
  margin: 0 .85714285714285714285714285714286rem 2.1428571428571428571428571428571rem .85714285714285714285714285714286rem;
}
#afis-app .concise-sitemap ul li {
  margin-bottom: 1rem;
}
#afis-app .ns-sub-menu a {
  color: #fff;
}
#afis-app .collapse {
  display: block;
}
#afis-app .ns-header [class*="span"] {
  margin-left: 11px;
}
#afis-app .ns-header .site-nav li {
  position: static;
  width: 127px;
}
#afis-app .state-accounts-active {
  display: none;
}
#afis-app #client-content-header {
  margin-top: 0;
  border-bottom: 0;
}
#afis-app #client-content-header .newLayout.ns-outer-control {
  padding-left: 0;
}
#afis-app #client-content-footer {
  padding: 0;
  border-top: 0;
  margin-top: 0;
}
#afis-app #loading-spinner {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed;
  background-size: auto;
  min-height: 1000px;
}
#afis-app #loading-spinner-2 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: auto;
  height: 66px;
  margin: 20px auto auto;
  width: 66px;
  z-index: 100;
}
#afis-app .about .row:first-child div ul {
  margin-bottom: 20px;
}
#afis-app .about ul {
  height: auto;
  margin-bottom: 30px;
  margin-left: 13px;
  vertical-align: middle;
}
#afis-app .about ul .social-media-badges {
  height: auto;
  margin: 0 !important;
  vertical-align: middle;
}
#afis-app .description i {
  background: none;
  display: inherit;
  vertical-align: baseline;
}
#afis-app .nowrap {
  white-space: nowrap;
}
#afis-app sup *,
#afis-app sub * {
  font-size: 8px;
}
#afis-app .institutional-blue {
  background-color: #ccebf9;
  padding-left: 10px;
  padding-right: 10px;
}
#afis-app .clear-both {
  clear: both;
}
/*This disables background scrolling when a boostrap modal is open on the ipad*/
@media (max-width: 769px) {
  body.modal-open {
    position: fixed;
  }
}
div.breadcrumb.parbase {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/common.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,+CAA+C;AACjD;AACA;;EAEE,0BAA0B;EAC1B,UAAU;AACZ;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,8DAA8D;EAC9D,6DAA6D;EAC7D,4DAA4D;EAC5D,2DAA2D;EAC3D,6FAA6F;EAC7F,gEAAgE;EAChE,cAAc;EACd,yDAAyD;EACzD,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mCAAmC;EACnC,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yDAAyD;EACzD,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,wDAAwD;EACxD,uDAAuD;EACvD,sDAAsD;EACtD,qDAAqD;EACrD,uFAAuF;EACvF,0DAA0D;EAC1D,WAAW;EACX,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,yDAAyD;EACzD,eAAe;AACjB;AACA;EACE,oEAAoE;AACtE;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,oDAAoD;EACpD,WAAW;AACb;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgDE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;EACf,yDAAyD;EACzD,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wHAAwH;AAC1H;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,aAAa;EACb,aAAa;AACf;AACA;EACE,iFAAmE;EACnE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,mDAAqC;EACrC,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA,+EAA+E;AAC/E;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,wBAAwB;AAC1B","sourcesContent":["#afis-app section {\n  border-top: 3px solid #666;\n  border-bottom: 1px solid #ccc;\n  padding: 0 13px 13px 13px;\n  background-color: #fff;\n  margin-top: 45px;\n}\n#afis-app #summary-section.sticky-margin-offset {\n  margin-top: 180px;\n}\n#afis-app .newnNavigation.utility-bar {\n  left: -13px;\n  width: 102.58%;\n}\n#afis-app .newnNavigation.utility-bar .ns-site-switch.cg-bootstrap {\n  height: 617px;\n}\n#afis-app .slide-enter-active {\n  transition: all .3s ease;\n}\n#afis-app .slide-leave-active {\n  transition: all 0.3s cubic-bezier(0, 1, 0.5, 1);\n}\n#afis-app .slide-enter,\n#afis-app .slide-leave-to {\n  transform: translateY(1px);\n  opacity: 0;\n}\n#afis-app .clearfix:after {\n  clear: both;\n  display: table;\n  content: \"\";\n}\n#afis-app .inner-container {\n  margin-left: auto;\n  margin-right: auto;\n}\n@media (min-width: 769px) {\n  #afis-app .inner-container {\n    width: 996px;\n  }\n}\n#afis-app .outer-container {\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 996px;\n}\n#afis-app .soft-gray {\n  background-color: #f9f9f9;\n}\n#afis-app .soft-gray .nav-responsive {\n  border-bottom: 3px solid #666;\n}\n#afis-app .soft-gray .nav-selected {\n  text-transform: uppercase;\n  background-color: #33aee5;\n  background-image: linear-gradient(to bottom, #33aee5, #009adf);\n  background-image: -moz-linear-gradient(top, #33aee5, #009adf);\n  background-image: -ms-linear-gradient(top, #33aee5, #009adf);\n  background-image: -o-linear-gradient(top, #33aee5, #009adf);\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#33aee5), to(#009adf));\n  background-image: -webkit-linear-gradient(top, #33aee5, #009adf);\n  display: block;\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n  font-size: 18px;\n  height: 36px;\n  line-height: 36px;\n  color: #fff;\n}\n#afis-app .soft-gray .nav-selected .nav-arrow-up {\n  border-bottom: 8px solid #fff;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  content: \"\";\n  display: block;\n  margin-right: 6px;\n  margin-top: 13px;\n}\n#afis-app .soft-gray .nav-selected .nav-arrow-down {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid #fff;\n  content: \"\";\n  display: block;\n  margin-right: 6px;\n  margin-top: 13px;\n}\n#afis-app .soft-gray .nav-list {\n  display: block;\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n  font-size: 18px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n#afis-app .soft-gray .nav-list .nav-item {\n  background-color: #999;\n  background-image: linear-gradient(to bottom, #999, gray);\n  background-image: -moz-linear-gradient(top, #999, gray);\n  background-image: -ms-linear-gradient(top, #999, gray);\n  background-image: -o-linear-gradient(top, #999, gray);\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#999), to(gray));\n  background-image: -webkit-linear-gradient(top, #999, gray);\n  color: #fff;\n  display: block;\n  height: 36px;\n  line-height: 36px;\n  text-transform: uppercase;\n}\n#afis-app .gray-bar-bottom {\n  border-bottom: 1px solid #ccc;\n}\n#afis-app .gray-bar-top {\n  border-top: 1px solid #ccc;\n}\n#afis-app #mega-menu[disabled] a {\n  color: #1d5799;\n  text-decoration: none;\n}\n#afis-app #header-row .logoCol img.logo {\n  margin-left: 15%;\n}\n#afis-app a:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n#afis-app .demi-font {\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n  font-size: 12px;\n}\n#afis-app .strong {\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif !important;\n}\n#afis-app .half-container {\n  float: left;\n  width: 49%;\n}\n#afis-app .flush-left {\n  padding-left: 0 !important;\n  margin-left: 0 !important;\n}\n#afis-app .flush-right {\n  padding-right: 0 !important;\n  margin-right: 0 !important;\n}\n#afis-app .com-mod-level-2-disclosure {\n  font-size: 12px;\n  font-family: \"AvenirNextLTW01-Condens 721299\", Arial;\n  color: #666;\n}\n#afis-app .col-xs-1,\n#afis-app .col-sm-1,\n#afis-app .col-md-1,\n#afis-app .col-lg-1,\n#afis-app .col-xs-2,\n#afis-app .col-sm-2,\n#afis-app .col-md-2,\n#afis-app .col-lg-2,\n#afis-app .col-xs-3,\n#afis-app .col-sm-3,\n#afis-app .col-md-3,\n#afis-app .col-lg-3,\n#afis-app .col-xs-4,\n#afis-app .col-sm-4,\n#afis-app .col-md-4,\n#afis-app .col-lg-4,\n#afis-app .col-xs-5,\n#afis-app .col-sm-5,\n#afis-app .col-md-5,\n#afis-app .col-lg-5,\n#afis-app .col-xs-6,\n#afis-app .col-sm-6,\n#afis-app .col-md-6,\n#afis-app .col-lg-6,\n#afis-app .col-xs-7,\n#afis-app .col-sm-7,\n#afis-app .col-md-7,\n#afis-app .col-lg-7,\n#afis-app .col-xs-8,\n#afis-app .col-sm-8,\n#afis-app .col-md-8,\n#afis-app .col-lg-8,\n#afis-app .col-xs-9,\n#afis-app .col-sm-9,\n#afis-app .col-md-9,\n#afis-app .col-lg-9,\n#afis-app .col-xs-10,\n#afis-app .col-sm-10,\n#afis-app .col-md-10,\n#afis-app .col-lg-10,\n#afis-app .col-xs-11,\n#afis-app .col-sm-11,\n#afis-app .col-md-11,\n#afis-app .col-lg-11,\n#afis-app .col-xs-12,\n#afis-app .col-sm-12,\n#afis-app .col-md-12,\n#afis-app .col-lg-12 {\n  position: relative;\n  min-height: 1px;\n  padding-left: 13px;\n  padding-right: 13px;\n}\n#afis-app .row {\n  margin-left: -13px;\n  margin-right: -13px;\n}\n#afis-app .not-found-outer {\n  background: #f2f2f2;\n}\n#afis-app .not-found-outer hr {\n  border-top: 1px solid #e5e5e5;\n  margin-top: 80px;\n  padding-bottom: 30px;\n  width: 996px;\n}\n#afis-app .not-found-outer a {\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n}\n#afis-app .not-found-outer .demi-font {\n  height: 96px;\n}\n#afis-app .not-found-container {\n  background: #fff;\n  width: 996px;\n}\n#afis-app .not-found-container .ns-rte {\n  margin-top: 25px;\n  margin-bottom: 30px;\n}\n#afis-app .not-found-container .ns-rte p {\n  margin: 0 0 9px;\n  font-size: 14px;\n  font-family: \"AvenirNextLTW01-Regular\", Arial, sans-serif;\n  color: #333;\n}\n#afis-app .inline {\n  display: inline;\n}\n@media (max-width: 768px) {\n  #afis-app section {\n    border-top: none;\n    margin-top: 0;\n  }\n  #afis-app .com-mod-section-header {\n    display: none;\n  }\n}\n#afis-app .concise-sitemap a {\n  color: #fff;\n}\n#afis-app .concise-sitemap [class*=\"span\"] {\n  margin-left: 21px;\n}\n#afis-app .concise-sitemap ul {\n  margin: 0 .85714285714285714285714285714286rem 2.1428571428571428571428571428571rem .85714285714285714285714285714286rem;\n}\n#afis-app .concise-sitemap ul li {\n  margin-bottom: 1rem;\n}\n#afis-app .ns-sub-menu a {\n  color: #fff;\n}\n#afis-app .collapse {\n  display: block;\n}\n#afis-app .ns-header [class*=\"span\"] {\n  margin-left: 11px;\n}\n#afis-app .ns-header .site-nav li {\n  position: static;\n  width: 127px;\n}\n#afis-app .state-accounts-active {\n  display: none;\n}\n#afis-app #client-content-header {\n  margin-top: 0;\n  border-bottom: 0;\n}\n#afis-app #client-content-header .newLayout.ns-outer-control {\n  padding-left: 0;\n}\n#afis-app #client-content-footer {\n  padding: 0;\n  border-top: 0;\n  margin-top: 0;\n}\n#afis-app #loading-spinner {\n  background: url('../img/loading.gif') no-repeat center center fixed;\n  background-size: auto;\n  min-height: 1000px;\n}\n#afis-app #loading-spinner-2 {\n  background: url('../img/loading.gif');\n  background-size: auto;\n  height: 66px;\n  margin: 20px auto auto;\n  width: 66px;\n  z-index: 100;\n}\n#afis-app .about .row:first-child div ul {\n  margin-bottom: 20px;\n}\n#afis-app .about ul {\n  height: auto;\n  margin-bottom: 30px;\n  margin-left: 13px;\n  vertical-align: middle;\n}\n#afis-app .about ul .social-media-badges {\n  height: auto;\n  margin: 0 !important;\n  vertical-align: middle;\n}\n#afis-app .description i {\n  background: none;\n  display: inherit;\n  vertical-align: baseline;\n}\n#afis-app .nowrap {\n  white-space: nowrap;\n}\n#afis-app sup *,\n#afis-app sub * {\n  font-size: 8px;\n}\n#afis-app .institutional-blue {\n  background-color: #ccebf9;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n#afis-app .clear-both {\n  clear: both;\n}\n/*This disables background scrolling when a boostrap modal is open on the ipad*/\n@media (max-width: 769px) {\n  body.modal-open {\n    position: fixed;\n  }\n}\ndiv.breadcrumb.parbase {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
